import React, { useState, useContext, useEffect } from "react";
import { isEmpty, get, values } from "lodash";
import { Button } from "react-bootstrap";
import * as Yup from "yup";
import {
  PlanCards,
  SearchableList,
  FieldDropSide,
  FieldButtonGroup,
  DistributionCard,
  UploadComponent,
  LoaderWrapper,
  ReviewSummary,
  RulesAndRegulationSlider,
  AddressSlide,
  BankSlide,
  SourceSplitupSlider,
  ContentPreviewer,
  UploadComponentLoans,
  UploadComponentWithDrawalSpousal,
  GrossAmountWarningModal,
} from "../../../components";
import {
  returnOnlyIfBoolean,
  yesNoOptions,
  getWithdrawalName,
  MANAGE_CENSUS_ROUTES,
  getPathWithParam,
  usDateFormat,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_TRANSACTION_ROUTES,
  getHardshipReason,
} from "../../../utils";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import {
  getCountriesList,
  getStates,
  getStatesList,
  getEmployeePlanWithdrawals,
  addAddress,
  addBank,
  getWithdrawalRequest,
  uploadWithdrawalDocumentsRequest,
  getStateTax,
} from "../../../services";
import ManageDistributionLayout from "../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons";
import { Field, Form, Formik, isEmptyArray } from "formik";
import {
  distributionFormFields,
  manageDistributionFormNames,
} from "../../../utils/constants/distribution";
import { useHistory } from "react-router-dom";
import {
  saveRequest,
  manageDistributionStore,
  setWithdrawalRequestPageData,
  uploadWithdrawalDocuments,
  MANAGE_DISTRIBUTION_POST_API_RESPONSE,
  setManageDistributionToastInfo,
  MANAGE_DISTRIBUTION_POST_API_ERROR,
} from "../../../contexts";
import { CalculateSourceSplit } from "../WithdrawalRequestContainer/CalculateSourceSplitup";

const accountTypeOptions = [
  {
    label: "Saving Account",
    value: 1,
  },

  {
    label: "Checking Account",
    value: 2,
  },
];

const date = new Date();
const today = new Date(date.setDate(date.getDate()));

const rkData = {
  sourceEmployeeMaps: [
    {
      sourceSubCategory: 4,
      sourceId: 1,
      sourceName: "PreTax",
      vestingMultiplier: 0.5,
      repaymentCCBBalance: 20,
      regularCCBBalance: 60,
      basisCCBBalance: 20,
      repaymentAccountBalance: 30,
      regularAccountBalance: 90,
      basisAccountBalance: 30,
      repaymentEarningsBalance: 10,
      regularEarningsBalance: 30,
      basisEarningsBalance: 10,
      totalAccountBalance: 150,
      sourceEmployeeInvestmentMaps: [
        {
          investmentId: 1,
          investmentName: "Equity",
          nav: 5,
          units: 15,
          repaymentCCBBalance: 10,
          regularCCBBalance: 30,
          basisCCBBalance: 10,
          repaymentAccountBalance: 15,
          regularAccountBalance: 45,
          basisAccountBalance: 15,
          repaymentEarningsBalance: 5,
          regularEarningsBalance: 15,
          basisEarningsBalance: 5,
          totalAccountBalance: 75,
        },
        {
          investmentId: 2,
          investmentName: "Bonds",
          nav: 5,
          units: 15,
          repaymentCCBBalance: 10,
          regularCCBBalance: 30,
          basisCCBBalance: 10,
          repaymentAccountBalance: 15,
          regularAccountBalance: 45,
          basisAccountBalance: 15,
          repaymentEarningsBalance: 5,
          regularEarningsBalance: 15,
          basisEarningsBalance: 5,
          totalAccountBalance: 75,
        },
      ],
    },
  ],
};

export const getTransformedBankDetails = (bankDetails) => {
  return {
    nameOfTheFinancialInstitution: bankDetails.nameOfTheFinancialInstitution,
    accountHolderName: bankDetails.accountHolderName,
    typeOfAccount: bankDetails.typeOfAccount,
    checkingSavingsAccountNumber: bankDetails.checkingSavingsAccountNumber,
    abaRoutingNumberforBankOfCreditUnion:
      bankDetails.abaRoutingNumberforBankOfCreditUnion,
  };
};

const WithdrawalRequestContainer = (props) => {
  const { censusId, flow, withdrawalRequestId, fromPage } = useRouterParams(); //fromPage -1 - from transactions page, 2 - from employee transaction page
  const { state, dispatch } = useContext(manageDistributionStore);
  const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
  const fields = distributionFormFields[formName];
  const history = useHistory();
  const [selectPlanError, setSelectPlanError] = useState("");
  const apiData = get(state, "api.data", []);
  const [stateList, setStateList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [isUpload, setIsUpload] = useState(false);
  const [employeeImage, setEmployeeImage] = useState("");
  const sourceBalances = get(state, "sourceSplit", []);
  const [sourceSplit, setSourceSplit] = useState([]);
  const [isUploadSuccess, setIsUploadSuccess] = useState(true);
  const [spousalConsentDocHidden, setSpousalConsentDocHidden] = useState(true);
  const [promissoryNoteHidden, setPromissoryNoteHidden] = useState(true);
  const [distribution, setDistribution] = useState([{ id: 1 }]);
  const AddDistributions = () => {
    setDistribution([...distribution, { id: 2 }]);
  };
  const [rulesAndRegulationSlide, setrulesAndRegulationSlide] = useState(false);
  const [bankSlideOpen, setBankSlideOpen] = useState(null);
  const [sourcesplitupslide, setsourcesplitupslide] = useState(false);
  const [addressSlideOpen, setAddressSlideOpen] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [address, setAddress] = useState([]);
  const [bankInformationDetails, setBankInformationDetails] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [employeePlans, setEmployeePlans] = useState([]);
  const [uploadDocuments, setuploadDocuments] = useState([]);
  const [newFileData, getNewFileData] = useState([]);
  const [responseModel, setResponseModel] = useState(apiData);
  const [responseLoading, setResponseLoading] = useState(false);
  const [transactionIndex, setTransactionIndex] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState(0);
  const [
    responceSpousalConsentFileUploadData,
    getResponceSpousalConsentFileUploadData,
  ] = useState([]);
  const [
    responcePromissoryNoteFileUploadData,
    getResponcePromissoryNoteFileUploadData,
  ] = useState([]);
  const [addWithdrawal, setAddWithdrawal] = useState(true);
  const [showWarning, setShowWarning] = useState(false);
  const WarningToastMessage =
    "Your requested amount is not the entire amount , Please change the values? ";
  const WarningToastMessageHead = "Caution? ";

  const planIndex = employeePlans?.findIndex(
    (x) => x.id == responseModel.planId
  );
  const getWithdrawal = !isEmpty(responseModel)
    ? employeePlans &&
      employeePlans[planIndex]?.withdrawals.find(
        (x) => x.id == responseModel.withdrawalId
      )
    : {};
  const [withdrawal, setWithdrawal] = useState();
  const [bankAdded, setBankAdded] = useState();
  const [addressAdded, setAddressAdded] = useState();
  const [availableAmount, setAvailableAmount] = useState([]);
  const [defaultStateTax, setDefaultStateTax] = useState(0);
  const grossSum = sourceSplit?.reduce(
    (a, v) => (a = a + v.grossWithdrawalAmount),
    0
  );
  // fetch(responseModel?.promissoryNoteFileUpload)
  //   .then((res) => res.blob())
  //   .then((blob) => {
  //     let objectURL = URL.createObjectURL(blob);
  //     let myImage = new Image();
  //     myImage.src = objectURL;
  //   });
  // useDeepEffect(
  //   () => {
  //     if (!isEmpty(get(responseModel, "promissoryNoteFileUpload"))) {
  //       fetch(responseModel?.promissoryNoteFileUpload)
  //         .then((res) => res.blob())
  //         .then((blob) => {
  //           let objectURL = URL.createObjectURL(blob);
  //           let myImage = new Image();
  //           myImage.src = objectURL;
  //         })
  //         .catch((err) => {
  //         });
  //     }
  //   },
  //   [responseModel],
  //   true
  // );
  // function dataURItoBlob(dataURI) {
  //   var byteString = atob(dataURI.split(",")[1]);
  //   var ab = new ArrayBuffer(byteString.length);
  //   var ia = new Uint8Array(ab);
  //   for (var i = 0; i < byteString.length; i++) {
  //     ia[i] = byteString.charCodeAt(i);
  //   }
  //   var bb = new Blob([ab]);
  //   return bb;
  // }
  const handleOkayClick = () => {
    setShowWarning(false);
  };

  useDeepEffect(() => {
    if (!isEmpty(address)) {
      let i = stateList?.findIndex(
        (x) => x.stateDescription == address[0][0].state
      );
      let id = stateList[i]?.id;
      if (id) {
        getStateTax(id)
          .then((response) => {
            if (response.isStateWithholdingApplicable)
              setDefaultStateTax(response.defaultvalue);
          })
          .catch((error) => {
            //Handle Error
          });
      }
    }
  }, [address, stateList]);

  useDeepEffect(() => {
    getCountriesList().then((response) => {
      setCountries(response);
    });
  }, [countries]);

  useDeepEffect(() => {
    getStates().then((response) => {
      setStateList(response);
    });
  }, [stateList]);

  const { response, loading } = useRequest({
    method: getEmployeePlanWithdrawals,
    payload: censusId,
  });
  function getFileNameFromBlobPath(url) {
    return url?.split("/")?.pop()?.split("_")[0];
  }
  function getFileExtensionFromBlobPath(url) {
    return url
      ?.split("/")
      ?.pop()
      ?.split("_")[1]
      ?.slice(
        ((url?.split("/")?.pop()?.split("_")[1].lastIndexOf(".") - 1) >>> 0) + 2
      );
  }
  useEffect(() => {
    if (get(responseModel, "spousalConsentFileUpload") != null) {
      let url = get(responseModel, "spousalConsentFileUpload");
      if (!isEmptyArray(url)) {
        const toDataURL = (url) =>
          fetch(url)
            .then((response) => response.blob())
            .then(
              (blob) =>
                new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                })
            )
            .catch((error) => {});

        function getBase64Image(url) {
          var canvas = document.createElement("canvas");
          var dataURL = canvas.toDataURL("image/png");
          return dataURL;
        }

        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, { type: mime });
        }

        toDataURL(url).then((dataUrl) => {
          var fileData = !isEmpty(dataUrl)
            ? dataURLtoFile(
                dataUrl,
                getFileNameFromBlobPath(
                  get(responseModel, "spousalConsentFileUpload")
                ) +
                  "." +
                  getFileExtensionFromBlobPath(
                    get(responseModel, "spousalConsentFileUpload")
                  )
              )
            : dataURLtoFile(
                getBase64Image(url),
                getFileNameFromBlobPath(
                  get(responseModel, "spousalConsentFileUpload")
                ) +
                  "." +
                  getFileExtensionFromBlobPath(
                    get(responseModel, "spousalConsentFileUpload")
                  )
              );
          getResponceSpousalConsentFileUploadData([fileData]);
        });
      }
    }
  }, [responseModel]);

  useEffect(() => {
    if (get(responseModel, "promissoryNoteFileUpload") != null) {
      let url = get(responseModel, "promissoryNoteFileUpload");
      if (!isEmptyArray(url)) {
        const toDataURL = (url) =>
          fetch(url)
            .then((response) => response.blob())
            .then(
              (blob) =>
                new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                })
            )
            .catch((error) => {});

        function getBase64Image(url) {
          var canvas = document.createElement("canvas");
          var dataURL = canvas.toDataURL("image/png");
          return dataURL;
        }

        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new File([u8arr], filename, { type: mime });
        }

        toDataURL(url).then((dataUrl) => {
          var fileData = !isEmpty(dataUrl)
            ? dataURLtoFile(
                dataUrl,
                getFileNameFromBlobPath(
                  get(responseModel, "promissoryNoteFileUpload")
                ) +
                  "." +
                  getFileExtensionFromBlobPath(
                    get(responseModel, "promissoryNoteFileUpload")
                  )
              )
            : dataURLtoFile(
                getBase64Image(url),
                getFileNameFromBlobPath(
                  get(responseModel, "promissoryNoteFileUpload")
                ) +
                  "." +
                  getFileExtensionFromBlobPath(
                    get(responseModel, "promissoryNoteFileUpload")
                  )
              );
          getResponcePromissoryNoteFileUploadData([fileData]);
        });
      }
    }
  }, [responseModel]);

  useDeepEffect(() => {
    if (withdrawalRequestId) {
      setResponseLoading(true);
      getWithdrawalRequest(withdrawalRequestId).then((response) => {
        setResponseModel({
          ...(response || {}),
          spousalConsentFileUpload: response?.spousalConsentFileUpload || [],
          promissoryNoteFileUpload: response?.promissoryNoteFileUpload || [],
        });
        response.withdrawalTransactions?.map((item, ind) => {
          sourceSplit[ind] = CalculateSourceSplit(
            ind == 0
              ? employeePlans && employeePlans[selectedPlan]?.sourceBalances
              : sourceSplit[ind - 1]["updatedSourceSplit"],
            item,
            withdrawal,
            response,
            ind >= (sourceSplit?.length ?? 0) ||
              ind == (sourceSplit?.length ?? 0) - 1
          );
        });
        setResponseLoading(false);
      });
    }
  }, [withdrawalRequestId]);

  const getSingleAddress = (address) =>
    `${
      (address.address1 && address.address1 + ", ") +
      (address.address2 && address.address2 + ", ") +
      (address.address3 && address.address3)
    }`;

  useDeepEffect(() => {
    if (!isEmpty(response)) {
      if (response?.address != null)
        setAddress([
          [
            response?.address
              ? {
                  ...response.address,
                  address1: getSingleAddress(response.address),
                  address2: null,
                  address3: null,
                }
              : null,
          ],
        ]);
      if (response?.bankInformationDetails != null)
        setBankInformationDetails([
          [getTransformedBankDetails(response.bankInformationDetails)],
        ]);
      setBeneficiaries(response.beneficiaries);
      setEmployeePlans(response.employeePlans);
    }
  }, [response]);

  useDeepEffect(() => {
    if (!isEmpty(responseModel)) {
      setSelectedPlan(planIndex);
      setWithdrawal(getWithdrawal);
    }
  }, [employeePlans]);

  const onFormSubmit = (
    values,
    { setFieldError, setFieldTouched, setSubmitting }
  ) => {
    if (addWithdrawal && values.withdrawEntireAmount) {
      setShowWarning(true);
    } else {
      setResponseLoading(true);
      let t = values.distribution.map((item, ind) => {
        var x = {
          id: item.id ? item.id : 0, //need to confirm
          sortOrder: ind + 1,
          code: item.code,
          distributionMode: item.distributionMode,
          payeeType: item.payeeType,
          paymentMethod: item.paymentMethod,
          beneficiaryId: item.beneficiaryId,
          bankInformation: item.bank,
          address: item.address,
          requestedAmount: item.requestedAmount,
          checkFee: item.paymentMethod == 1 ? item.checkFee : null,
          withdrawalFee: item.distributionMode == 1 ? item.withdrawalFee : null,
          rollOverFee: item.distributionMode != 1 ? item.rollOverFee : null,
          eftFee: item.paymentMethod == 2 ? item.eftFee : null,
          stateTax: item.stateTax,
          federalTax: item.federalTax,
          withdrawalRequestId: withdrawalRequestId ? withdrawalRequestId : 0,
          waiveOffLimitApplicable: item.waiveOffLimitApplicable,
          waiveOffLimit: item.waiveOffLimit,
          waiveOffLimitReason: item.waiveOffLimitReason,
          earlyWithdrawalPenalty: item.earlyWithdrawalPenalty,
          iraNumber: item.iraNumber,
          nameOfTheFinancialInstitution: item.nameOfTheFinancialInstitution,
          planName: employeePlans[selectedPlan].planName,
          trusteeName: item.trusteeName,
          planId: values.planId,
          sourceWithdrawal: [],
        };
        if (x.paymentMethod == 1) {
          x = { ...x, bankInformation: null };
        } else {
          x = { ...x, address: null };
        }
        return x;
      });

      const today = new Date();
      let x = {
        id: responseModel?.id ? responseModel.id : 0,
        employeeId: parseInt(censusId),
        planId: values.planId,
        planName: values.planName,
        withdrawEntireAmount: values.withdrawEntireAmount,
        withdrawalId: withdrawal ? withdrawal.id : values.withdrawalId,
        userId: 1,
        withdrawalStatus: withdrawalRequestId
          ? responseModel.withdrawalStatus
          : 1, //change later
        withdrawalTransactions: t,
        withDrawalType: values.withdrawalType,
        requestDate: new Date(today.setDate(today.getDate())),
        isDraft: false,
      };
      if (values.planId && values.withdrawalType) {
        saveRequest(x, dispatch)
          .then((response) => {
            if (response.isSuccessful) {
              setResponseLoading(false);
              dispatch(
                setWithdrawalRequestPageData({
                  formName: "planName",
                  fieldData: values.planName,
                })
              );
              dispatch(
                setWithdrawalRequestPageData({
                  formName: "withdrawalType",
                  fieldData: values.withdrawalType,
                })
              );
              dispatch(
                setWithdrawalRequestPageData({
                  formName: "sourceSplit",
                  fieldData: sourceSplit,
                })
              );
              if (
                !isEmpty(values[fields.spousalConsentFileUpload]) ||
                !isEmpty(values[fields.promissoryNoteFileUpload])
              ) {
                setResponseLoading(true);
                var formData = new FormData();
                formData?.append(
                  "spousalConsentFileUpload",
                  !isEmptyArray(values[fields.spousalConsentFileUpload])
                    ? values[fields.spousalConsentFileUpload][0]
                    : responseModel.spousalConsentFileUpload
                );
                formData?.append(
                  "promissoryNoteFileUpload",
                  !isEmptyArray(values[fields.promissoryNoteFileUpload])
                    ? values[fields.promissoryNoteFileUpload][0]
                    : responseModel.promissoryNoteFileUpload
                );
                formData?.append(
                  "withdrawalRequestId",
                  !isEmpty(responseModel)
                    ? responseModel.id
                    : response.withdrawalRequest.id
                );
                uploadWithdrawalDocuments(formData, dispatch)
                  .then((res) => {
                    dispatch(
                      setManageDistributionToastInfo({
                        showToast: true,
                        toastMessage: "Data saved successfully",
                      })
                    );
                    setResponseLoading(false);
                    setuploadDocuments({
                      ...res,
                      withdrawalRequest: {
                        ...(res?.withdrawalRequest || {}),
                        spousalConsentFileUpload:
                          res?.withdrawalRequest?.spousalConsentFileUpload ||
                          [],
                        promissoryNoteFileUpload:
                          res?.withdrawalRequest?.promissoryNoteFileUpload ||
                          [],
                      },
                    });
                    history.push(
                      getPathWithParam({
                        path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}`,
                        pathParam: [
                          flow,
                          censusId,
                          response?.withdrawalRequest?.id,
                        ],
                      })
                    );
                  })
                  .catch((error) => {
                    setResponseLoading(false);
                    dispatch({
                      type: MANAGE_DISTRIBUTION_POST_API_ERROR,
                      payload: error,
                    });
                  });
              } else {
                setResponseLoading(false);
                dispatch(
                  setManageDistributionToastInfo({
                    showToast: true,
                    toastMessage: "Data saved successfully",
                  })
                );
                fromPage == 1
                  ? history.push(
                      getPathWithParam({
                        path: `${MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWALAPPROVAL}`,
                        pathParam: [
                          flow,
                          censusId,
                          withdrawalRequestId,
                          fromPage,
                        ],
                      })
                    )
                  : history.push(
                      getPathWithParam({
                        path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}`,
                        pathParam: [
                          flow,
                          censusId,
                          response?.withdrawalRequest?.id,
                        ],
                      })
                    );
              }
            } else {
              if (
                withdrawal?.spouseConsentRequired &&
                isEmptyArray(values[fields.spousalConsentFileUpload])
              ) {
                setIsUploadSuccess(false);
                dispatch({
                  type: MANAGE_DISTRIBUTION_POST_API_ERROR,
                  payload: "error",
                });
              }
              setResponseLoading(false);
              setSubmitting(false);
              for (var i = 0; i < response.errorMessages?.length; i++) {
                var _ = response.errorMessages[i];
                setFieldTouched(_.controlName, true);
                setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
              }
            }
          })
          .catch((error) => {
            setResponseLoading(false);
          });
      } else {
        setResponseLoading(false);
        setSelectPlanError("* RI024 : Required");
      }
    }
  };

  const buttons =
    fromPage == 1
      ? [
          {
            label: "Cancel",
            variant: "secondary",
            type: "button",
            link: getPathWithParam({
              path: MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL,
              // pathParam: [],
            }),
          },
          {
            label: "Next",
            variant: "primary",
            type: "submit",

            // link: getPathWithParam({
            //   path: MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWALAPPROVAL,
            //   pathParam: [flow, censusId, withdrawalRequestId, fromPage],
            // }),
          },
        ]
      : fromPage == 4
      ? [
          {
            //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
            link: getPathWithParam({
              path: MANAGE_TRANSACTION_ROUTES.DRAFT,
            }),
            label: "Cancel",
            variant: "secondary",
            type: "button",
            //flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
          },
          {
            label: "Next",
            variant: "primary",
            //type: "submit",
            link: getPathWithParam({
              path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}`,
              pathParam: [flow, censusId, withdrawalRequestId, fromPage],
            }),
          },
        ]
      : [
          {
            //link: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
            link: getPathWithParam({
              path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
              pathParam: censusId,
            }),
            label: "Cancel",
            variant: "secondary",
            type: "button",
            //flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
          },
          {
            label: "Next",
            variant: "primary",
            type: "submit",
            // link: ROUTES.WITHDRAWAL_SUMMARY,
          },
        ];
  const onAddressSave = (values, index) => {
    let x = {
      id: 0,
      employeeId: parseInt(censusId),
      checkPayableTo: values.checkPayableTo,
      address1: values.address1,
      city: values.city,
      country: values.country,
      primaryEmailAddress: values.emailId,
      mobileNumber: values.mobileNumber,
      state: values.state,
      stateId: values.stateId,
      zipCode: values.zipCode?.toString(),
      withdrawalTransactionId: 0,
    };
    if (response.address != null) {
      address[index] = [address[index][0], x];
    } else {
      address[index] = [x];
    }
    setAddressSlideOpen(null);
  };

  const onBankSave = (values, index) => {
    let x = {
      id: 0,
      employeeId: parseInt(censusId),
      nameOfTheFinancialInstitution: values.bankName,
      accountHolderName: values.accountHolderName,
      typeOfAccount: values.accountType,
      checkingSavingsAccountNumber: values.accountNumber,
      abaRoutingNumberforBankOfCreditUnion: values.creditUnion,
    };
    if (response.bankInformationDetails != null) {
      setBankInformationDetails(
        bankInformationDetails.map((_, i) => {
          if (i === index) return [_[0], x];
          return _;
        })
      );
    } else {
      setBankInformationDetails(
        bankInformationDetails.map((_, i) => {
          if (i === index) return [x];
          return _;
        })
      );
    }
  };

  // const validationSchema = Yup.object({
  //   distribution: Yup.array().of(
  //     Yup.object().shape({
  //       address: Yup.array().of(
  //         Yup.object().shape({
  //           // checkPayableTo: Yup.string().required("Required"),
  //           // city: Yup.string().required("Required"),
  //         })
  //       ),
  //       // netWithdrawalAmount: Yup.string()
  //       //   .required("Required")
  //       //   .test(
  //       //     "netWithdrawalAmount",
  //       //     "Requested amount should not be greater than vested balance",
  //       //     (val) => (val <= employeePlans[selectedPlan].vestedBalance ? true : false)
  //       //   ),
  //       // grossWithdrawalAmount: Yup.string()
  //       //   .required("Required")
  //       //   .test(
  //       //     "grossWithdrawalAmount",
  //       //     "Gross total amount should not be greater than vested balance",
  //       //     (val) => (val <= employeePlans[selectedPlan].vestedBalance ? true : false)
  //       //   ),
  //       // paymentOption: Yup.string().required("Required"),
  //       // payee: Yup.string().required("Required"),
  //       // checkFee: Yup.string().required("Required"),
  //       // eftFee: Yup.string().required("Required"),

  //     })
  //   ),
  // });
  const validationSchema = Yup.object().shape({
    spousalConsentFileUpload: Yup.string().required("CM047 : Required"),
  });
  return (
    <LoaderWrapper isLoading={loading || responseLoading} loaderText="">
      <Formik
        initialValues={{
          planId: get(
            responseModel,
            "planId",
            employeePlans ? employeePlans[selectedPlan]?.id : null
          ),
          planName: get(
            state,
            "planName",
            employeePlans ? employeePlans[selectedPlan]?.planName : null
          ),
          withdrawEntireAmount: get(
            responseModel,
            "withdrawEntireAmount",
            null
          ),
          spousalConsentFileUpload: responceSpousalConsentFileUploadData,
          promissoryNoteFileUpload: responcePromissoryNoteFileUploadData,
          withdrawalType:
            getWithdrawal && get(getWithdrawal, "withDrawalType", null),
          withdrawalName:
            getWithdrawal &&
            `${getWithdrawalName(get(getWithdrawal, "withDrawalType", ""))}${
              get(getWithdrawal, "withDrawalType", null) == 2
                ? getHardshipReason(get(getWithdrawal, "hardshipReason", ""))
                : get(getWithdrawal, "withdrawalDescription", "")
            }`,
          withdrawalId: get(responseModel, "withdrawalId", null),
          distribution: responseModel?.withdrawalTransactions,
        }}
        enableReinitialize
        onSubmit={onFormSubmit}
        validateOnChange={false}
        // validationSchema={validationSchema}
        validateOnBlur={false}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;
          const vestedBalance = employeePlans
            ? employeePlans[selectedPlan]?.sourceBalances
                ?.reduce(
                  (a, v) =>
                    (a =
                      a +
                      v.vestingMultiplier *
                        v.sourceEmployeeMap?.accountBalance),
                  0
                )
                ?.toFixed(2)
            : 0;
          const distLength = values?.distribution?.length ?? 0;
          const addComponent = () => {
            if (grossSum < availableAmount[0]) {
              setValues({
                ...values,
                distribution: [
                  ...values.distribution,
                  {
                    vestedBalance: vestedBalance - parseFloat(grossSum),
                    checkFee: withdrawal?.checkFees,
                    eftFee: withdrawal?.eftFee,
                    withdrawalFee: withdrawal?.withdrawalOneTimeOriginateFee,
                    rollOverFee: withdrawal?.rollOverFee,
                    federalTax: 20,
                    payeeType: 1,
                    paymentMethod:
                      withdrawal && withdrawal?.paymentMethod.length == 1
                        ? withdrawal?.paymentMethod[0]
                        : null,
                    earlyWithdrawalPenalty: withdrawal?.earlyWithdrawalPenalty,
                    waiveOffLimit: withdrawal?.earlyWithdrawalPenalty,
                    stateTax: defaultStateTax,
                  },
                ],
              });
              setAddress([
                ...address,
                response?.address
                  ? [
                      {
                        ...response.address,
                        address1: getSingleAddress(response.address),
                        address2: null,
                        address3: null,
                      },
                    ]
                  : [],
              ]);
              setBankInformationDetails([
                ...bankInformationDetails,
                response.bankInformationDetails != null
                  ? [getTransformedBankDetails(response.bankInformationDetails)]
                  : [],
              ]);
            }
          };
          const deleteComponent = (itemIndex) => {
            let newValues = values.distribution.filter(
              (x, i) => i != itemIndex
            );
            setValues({ ...values, distribution: newValues });
          };

          const onWithDrawalChange = (value, label) => {
            setValues({
              ...values,
              [fields.withdrawalType]:
                employeePlans[selectedPlan].withdrawals[value].withDrawalType,
              [fields.withdrawalName]: label,
              [fields.withdrawalId]:
                employeePlans[selectedPlan].withdrawals[value].id,
              distribution: responseModel?.withdrawalTransactions
                ? responseModel.withdrawalTransactions
                : [
                    {
                      vestedBalance: employeePlans
                        ? employeePlans[selectedPlan]?.sourceBalances?.reduce(
                            (a, v) =>
                              (a =
                                a +
                                v.vestingMultiplier *
                                  v.sourceEmployeeMap?.accountBalance),
                            0
                          )
                        : 0,
                      checkFee:
                        employeePlans[selectedPlan].withdrawals[value]
                          ?.checkFees ?? 0,
                      eftFee:
                        employeePlans[selectedPlan].withdrawals[value]
                          ?.eftFee ?? 0,
                      withdrawalFee:
                        employeePlans[selectedPlan].withdrawals[value]
                          ?.withdrawalOneTimeOriginateFee ?? 0,
                      rollOverFee:
                        employeePlans[selectedPlan].withdrawals[value]
                          ?.rollOverFee ?? 0,
                      stateTax: defaultStateTax,
                      federalTax: 20,
                      payeeType: 1,
                      distributionMode: null,
                      paymentMethod:
                        employeePlans[selectedPlan].withdrawals[value]
                          ?.paymentMethod?.length == 1
                          ? employeePlans[selectedPlan].withdrawals[value]
                              ?.paymentMethod[0]
                          : 1,
                      earlyWithdrawalPenalty:
                        employeePlans[selectedPlan].withdrawals[value]
                          ?.earlyWithdrawalPenalty ?? 0,
                      waiveOffLimitApplicable: true,
                      waiveOffLimit:
                        employeePlans[selectedPlan].withdrawals[value]
                          ?.earlyWithdrawalPenalty ?? 0,
                      address: response?.address
                        ? {
                            ...response.address,
                            address1: getSingleAddress(response.address),
                            address2: null,
                            address3: null,
                          }
                        : null,
                      bank: response?.bankInformationDetails
                        ? getTransformedBankDetails(
                            response?.bankInformationDetails
                          )
                        : null,
                      // ? null
                      // : bankInformationDetails[0],
                    },
                  ],
            });
            setWithdrawal(employeePlans[selectedPlan].withdrawals[value]);
          };
          return (
            <Form onSubmit={handleSubmit} validated={!isEmpty(rest.errors)}>
              <ManageDistributionLayout
                isWithdrawalRequest={true}
                setSelectPlanError={setSelectPlanError}
                buttons={buttons}
                layoutHeader="New Withdrawal Request"
                values={values}
                censusId={censusId}
                employeeImage={employeeImage}
                withdrawalRequestId={withdrawalRequestId}
                planId={values.planId}
                withdrawalId={withdrawal && withdrawal?.id}
              >
                <div className="d-flex flex-row W-100 H-100 pr-15">
                  <div className="W-70 mr-30 px-20-10 overflow-Y H-80">
                    <p className=" ft-16 fw-500 Dark-Grey-Color">Select Plan</p>
                    <div className="d-flex flex-row">
                      <FontAwesomeIcon
                        className="fw-300 ft-14 Dark-Grey-Color mr-1"
                        icon={faExclamationCircle}
                      />
                      <p className="fw-400 ft-12 ">
                        The available amount is reported as of{" "}
                        <span className="fw-500 ">{usDateFormat(today)}</span>{" "}
                        and may change due to market fluctuations.
                      </p>
                    </div>
                    <p className="rollOverErrorStyle">{selectPlanError}</p>
                    <PlanCards
                      {...formProps}
                      plans={
                        withdrawalRequestId
                          ? [employeePlans[selectedPlan]]
                          : employeePlans
                      }
                      fields={fields}
                      selectedPlan={selectedPlan}
                      setSelectedPlan={setSelectedPlan}
                    />
                    <p className="ft-16 fw-500 Dark-Grey-Color mt-15">
                      Select Withdrawal Type
                    </p>
                    <Field
                      size="md"
                      name={fields.withdrawalName}
                      value={values[fields.withdrawalName]}
                      direction="bottom"
                      placeholder="Select a withdrawal type"
                      disabled={!isEmpty(withdrawalRequestId)}
                      popupContent={
                        <SearchableList
                          label="Select a withdrawal type"
                          options={
                            employeePlans[selectedPlan] &&
                            employeePlans[selectedPlan].withdrawals?.map(
                              (val, index) => ({
                                label:
                                  val.withDrawalType == 2
                                    ? `${getWithdrawalName(
                                        val.withDrawalType
                                      )}${getHardshipReason(
                                        val.hardshipReason
                                      )}`
                                    : `${getWithdrawalName(
                                        val.withDrawalType
                                      )}${val.withdrawalDescription}`,
                                value: index,
                              })
                            )
                          }
                          onSelect={(value, label) => {
                            onWithDrawalChange(value, label);
                          }}
                          selectedValue={values[fields.withdrawalName]}
                        />
                      }
                      validate={(value) => {
                        return [undefined, null, ""].includes(value)
                          ? "WL001 : Required"
                          : undefined;
                      }}
                      component={FieldDropSide}
                    />
                    <p className="rollOverErrorStyle">{selectPlanError}</p>
                    <div className="d-flex flex-row">
                      <FontAwesomeIcon
                        className="fw-500 ft-14 Light-Blue mr-1"
                        icon={faExclamationCircle}
                        style={{
                          paddingTop: "3px",
                          fontSize: "18px",
                          fontWeight: "500",
                        }}
                      />
                      <p
                        onClick={() => setrulesAndRegulationSlide(true)}
                        className="fw-400 ft-14 Light-Blue cursor-pointer"
                      >
                        Rules and regulations .
                      </p>
                    </div>
                    {values.withdrawalType && (
                      <>
                        <p className="fw-400 ft-14 Dark-Grey-Color">
                          Withdraw entire available amount
                        </p>
                        <Field
                          // isRequired
                          name={fields.withdrawEntireAmount}
                          size="sm"
                          options={yesNoOptions}
                          selectedValue={returnOnlyIfBoolean(
                            values[fields.withdrawEntireAmount]
                          )}
                          onChange={(value) => {
                            if (value == true)
                              setFieldValue(
                                `[distribution][0].${fields.requestedAmount}`,
                                null
                              );
                            setFieldValue(fields.withdrawEntireAmount, value);
                          }}
                          onClick={() => addComponent()}
                          //disabled={isEdit && !isSave}
                          validate={(value) => {
                            return [undefined, null, ""].includes(value)
                              ? "WL052 : Required"
                              : undefined;
                          }}
                          component={FieldButtonGroup}
                        />
                        {values.withdrawEntireAmount != null && (
                          <>
                            {values.distribution.map((data, index) => {
                              let addressList = address;
                              let bankList = bankInformationDetails;
                              return (
                                <>
                                  <DistributionCard
                                    {...formProps}
                                    setAddWithdrawal={setAddWithdrawal}
                                    addressList={address}
                                    fields={fields}
                                    rkData={
                                      employeePlans &&
                                      employeePlans[selectedPlan]
                                        ?.sourceBalances
                                    }
                                    setAddress={setAddress}
                                    bankAdded={bankAdded}
                                    setBankAdded={setBankAdded}
                                    addressAdded={addressAdded}
                                    setAddressAdded={setAddressAdded}
                                    defaultaddress={response?.address}
                                    defaultBankInformation={
                                      response?.bankInformationDetails
                                    }
                                    sourceSplit={sourceSplit}
                                    data={data}
                                    index={index}
                                    responseModel={
                                      responseModel.withdrawalTransactions
                                    }
                                    deleteComponent={deleteComponent}
                                    distLength={distLength}
                                    setBankSlideOpen={setBankSlideOpen}
                                    setSourceSplit={setSourceSplit}
                                    setAddressSlideOpen={setAddressSlideOpen}
                                    setsourcesplitupslide={
                                      setsourcesplitupslide
                                    }
                                    setDistribution={setDistribution}
                                    distribution={distribution}
                                    beneficiaries={beneficiaries}
                                    address={get(addressList, index, [])}
                                    bankInformationDetails={get(
                                      bankList,
                                      index,
                                      []
                                    )}
                                    bankList={bankList}
                                    setBankInformationDetails={
                                      setBankInformationDetails
                                    }
                                    withdrawal={withdrawal}
                                    vestedBalance={vestedBalance}
                                    stateList={stateList}
                                    setTransactionIndex={setTransactionIndex}
                                    availableAmount={availableAmount}
                                    setAvailableAmount={setAvailableAmount}
                                  />
                                  {/* Bank details slider */}
                                  <BankSlide
                                    {...formProps}
                                    index={index}
                                    setBankSlideOpen={setBankSlideOpen}
                                    bankSlideOpen={bankSlideOpen}
                                    bankInformationDetails={
                                      bankInformationDetails
                                    }
                                    onBankSave={onBankSave}
                                    bankAdded={bankAdded}
                                    setBankAdded={setBankAdded}
                                    fields={fields}
                                    accountTypeOptions={accountTypeOptions}
                                    FieldButtonGroup={FieldButtonGroup}
                                  />

                                  {/* Address Details */}
                                  <AddressSlide
                                    {...formProps}
                                    index={index}
                                    countries={countries}
                                    fields={fields}
                                    addressAdded={addressAdded}
                                    setAddressAdded={setAddressAdded}
                                    addressSlideOpen={addressSlideOpen}
                                    setAddressSlideOpen={setAddressSlideOpen}
                                    onAddressSave={onAddressSave}
                                    setStateList={setStateList}
                                    getStatesList={getStatesList}
                                    stateList={stateList}
                                    SearchableList={SearchableList}
                                    address={address}
                                  />
                                </>
                              );
                            })}
                            {values.withdrawalType != 1 &&
                              values.withdrawalType != 2 &&
                              addWithdrawal &&
                              distLength < 4 && (
                                <div className="d-flex flex-end">
                                  <Button
                                    className="bg-Light-Blue White Border-None"
                                    onClick={() => addComponent()}
                                  >
                                    Add withdrawal
                                  </Button>
                                </div>
                              )}
                            <div className="upload-documents">
                              <p className="ft-16 fw-500 Dark-grey-Color m-0-p-0">
                                Upload Documents
                              </p>
                              <div className="W-100 d-flex flex-row">
                                <div className="W-50 px-50-30 Border-Solid Border-None-right H-142 mt-25">
                                  <p className="fw-600 ft-14 Black m-0">
                                    Spousal Consent
                                    {withdrawal?.spouseConsentRequired
                                      ? " (required)"
                                      : " (Optional)"}
                                  </p>
                                  <div className="d-flex flex-row justify-content-between">
                                    <p
                                      className="fw-400 ft-12 Grey-Color m-0 mr-10"
                                      style={{ width: "180px" }}
                                    >
                                      Accepted file : pdf, word, txt, jpg, jpeg,
                                      excel, png, csv
                                    </p>
                                    <p className="fw-400 ft-12 Grey-Color m-0">
                                      Max File Size: 2 MB
                                    </p>
                                  </div>
                                </div>
                                <div className="W-50">
                                  <UploadComponentWithDrawalSpousal
                                    isUploadSuccess={isUploadSuccess}
                                    setFieldValue={setFieldValue}
                                    enablePreview={true}
                                    name={fields.spousalConsentFileUpload}
                                    fileExtensions=".jpeg, .png, .jpg, .pdf"
                                    values={values}
                                    responseModel={responseModel}
                                    documentHidden={spousalConsentDocHidden}
                                    setDocumentHidden={
                                      setSpousalConsentDocHidden
                                    }
                                  />
                                </div>
                              </div>
                              <div>
                                {values[fields.spousalConsentFileUpload] &&
                                  !spousalConsentDocHidden && (
                                    <ContentPreviewer
                                      data={
                                        !isEmptyArray(
                                          values[
                                            fields.spousalConsentFileUpload
                                          ]
                                        )
                                          ? URL.createObjectURL(
                                              values[
                                                fields.spousalConsentFileUpload
                                              ][0]
                                            )
                                          : responseModel.spousalConsentFileUpload
                                      }
                                    />
                                  )}
                              </div>
                            </div>
                            <div className="W-100 d-flex flex-row">
                              <div
                                style={{
                                  width: "50%",
                                  padding: "40px 10px 0px 30px",
                                  border: "0.5px solid #BDBDBD",
                                  borderRight: "none",
                                  height: "142px",
                                  marginTop: "25px",
                                }}
                              >
                                <p className="fw-600 ft-14 Black m-0 mb-3">
                                  WP_401(k) FORM (Optional)
                                </p>
                                <div className="d-flex flex-row justify-content-between">
                                  <p
                                    className="fw-400 ft-12 Grey-Color m-0 mr-10"
                                    style={{ width: "180px" }}
                                  >
                                    Accepted file : pdf, word, txt, jpg, jpeg,
                                    excel, png, csv
                                  </p>
                                  <p className="fw-400 ft-12 Grey-Color m-0">
                                    Max File Size: 2 MB
                                  </p>
                                </div>
                              </div>
                              <div className="W-50">
                                <UploadComponentLoans
                                  isUploadSuccess={true}
                                  setFieldValue={setFieldValue}
                                  enablePreview={true}
                                  name={fields.promissoryNoteFileUpload}
                                  fileExtensions=".jpeg, .png, .jpg, .pdf"
                                  values={values}
                                  responseModel={responseModel}
                                  documentHidden={promissoryNoteHidden}
                                  setDocumentHidden={setPromissoryNoteHidden}
                                />
                              </div>
                            </div>
                            <div>
                              {values[fields.promissoryNoteFileUpload] &&
                                !promissoryNoteHidden && (
                                  <ContentPreviewer
                                    data={
                                      !isEmptyArray(
                                        values[fields.promissoryNoteFileUpload]
                                      )
                                        ? URL.createObjectURL(
                                            values[
                                              fields.promissoryNoteFileUpload
                                            ][0]
                                          )
                                        : responseModel.promissoryNoteFileUpload
                                    }
                                  />
                                )}
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  <ReviewSummary
                    values={values}
                    employeePlans={employeePlans}
                    selectedPlan={selectedPlan}
                    vestedBalance={vestedBalance}
                    grossSum={grossSum}
                    getWithdrawalName={getWithdrawalName}
                    sourceSplit={sourceSplit}
                  />
                </div>

                {/* Rules slider */}
                <RulesAndRegulationSlider
                  setrulesAndRegulationSlide={setrulesAndRegulationSlide}
                  rulesAndRegulationSlide={rulesAndRegulationSlide}
                />

                {/* sourcesplitupslide */}
                <SourceSplitupSlider
                  sourcesplitupslide={sourcesplitupslide}
                  setsourcesplitupslide={setsourcesplitupslide}
                  sourceSplit={sourceSplit && sourceSplit[transactionIndex]}
                  activeIndex={activeIndex}
                  setActiveIndex={setActiveIndex}
                  values={
                    values.distribution && values.distribution[transactionIndex]
                  }
                />
              </ManageDistributionLayout>
              <GrossAmountWarningModal
                WarningToastMessageHead={WarningToastMessageHead}
                WarningToastMessage={WarningToastMessage}
                showModal={showWarning}
                //handleConfirmClick={handleConfirmClick}
                handleOkayClick={handleOkayClick}
              />
            </Form>
          );
        }}
      </Formik>
    </LoaderWrapper>
  );
};

export default WithdrawalRequestContainer;
